<mwe-basic-card>
  <div role="list">
    @for (item of items(); track $index) {
      <div role="listitem">
        @if ($index) {
          <hr />
        }
        @if (item.clickFunc) {
          <a
            class="clickable-secondary fw-bold"
            [attr.data-test]="item.dataTestSelector"
            [translate]="item.label"
            (click)="item.clickFunc()"
            href="javascript:void(0)"
          ></a>
        }
        @if (item.href) {
          <a
            class="clickable-secondary fw-bold"
            [translate]="item.label"
            target="_blank"
            [attr.data-test]="item.dataTestSelector"
            [href]="item.href"
            rel="noopener noreferrer"
          ></a>
        }
      </div>
    }
  </div>
</mwe-basic-card>
